import useStyles from 'isomorphic-style-loader/useStyles';
import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import s from './HeadMessage.css';

/**
 * Шапка страницы с крупным заголовком.
 *
 * @param {'compact'} [variant] уменьшенный вариант для контентных страниц
 */
export default function HeadMessage({ children, variant }) {
	useStyles(s);

	return (
		<div className={classNames(s.Head, variant === 'compact' && s.compact)}>
			{children}
		</div>
	);
}

HeadMessage.propTypes = {
	children: PropTypes.node.isRequired,
	variant: PropTypes.string,
};

HeadMessage.defaultProps = {
	variant: undefined,
};
